import { parseISO, format } from "date-fns";
const formatString = "dd.MM.yyyy";
const formatWithTimeString = "dd.MM.yyyy HH:mm";

export const getDateFormat = (str: string | undefined) => {
    if (!str) return "";
    const date = parseISO(str ?? ""); // Парсим ISO строку

    return format(date, formatString);
};

export const getDateTimeFormat = (str: string | undefined) => {
    if (!str) return "";
    const date = parseISO(str ?? ""); // Парсим ISO строку

    return format(date, formatWithTimeString);
};


